export default {
  imgs: [
    {
      name: "背景",
      src: require("@img/battle/bg.jpg"),
    },
    {
      name: "城堡",
      src: require("@img/battle/build.png"),
    },
    {
      name: "火1",
      src: require("@img/battle/fire_1.png"),
    },
    {
      name: "火2",
      src: require("@img/battle/fire_2.png"),
    },
    {
      name: "火3",
      src: require("@img/battle/fire_3.png"),
    },
    {
      name: "走光",
      src: require("@img/battle/light.png"),
    },
    {
      name: "对手背景",
      src: require("@img/battle/ready_top.jpg"),
    },
    {
      name: "自己背景",
      src: require("@img/battle/ready_bottom.jpg"),
    },
    {
      name: "vs",
      src: require("@img/battle/vs.png"),
    },
    // {
    //   name: "对战动画",
    //   src: require("@img/battle/battle-gif.gif"),
    // },
    {
      name: "排行榜排名背景",
      src: require("@img/battle/rank-pop_rank.png"),
    },
    {
      name: "排行榜我的背景",
      src: require("@img/battle/rank-pop_my.png"),
    },
    {
      name: "弹窗头部",
      src: require("@img/battle/pop-title.png"),
    },
    {
      name: "失败头部",
      src: require("@img/battle/result-title_lost.png"),
    },
    {
      name: "宝箱",
      src: require("@img/battle/box.png"),
    },
    {
      name: "失败",
      src: require("@img/battle/lost.png"),
    },
    {
      name: "击败icon",
      src: require("@img/battle/ko.png"),
    },
  ],
};
